import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking';
import AcademyOnboardingLandingPage from '../components/AcademyOnboardingLandingPage';
import { HasGate } from '../../accounts';
import ACForbiddenError from 'academy-common-lib/components/error/ACForbiddenError';
import { jsx as _jsx } from "react/jsx-runtime";
const AcademyOnboarding = () => {
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.ACADEMY_ONBOARDING
    });
  }, []);
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsx(ACForbiddenError, {}) // TODO: Update the fallback component
    ,
    gate: "AcademyAchievements::Onboarding::LiveEvents",
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "ACADEMY_ONBOARDING_LANDING_PAGE_LOADED",
      children: /*#__PURE__*/_jsx(AcademyOnboardingLandingPage, {})
    })
  });
};
export default AcademyOnboarding;